import { GameProps } from '@/components/Gameinterfaces';
import { CouponNumberGroupConfig } from '@/config/game';

export type UpdateCouponNumbersCallback = (
  config: CouponNumberGroupConfig,
  i: number,
  excluded: number[]
) => number[];

export function updateCouponNumbers(
  coupon: number,
  props: GameProps,
  values: number[] | UpdateCouponNumbersCallback
): void {
  if (!!props.couponGroup) {
    props.couponGroup.numberGroups.forEach(
      (config: CouponNumberGroupConfig, group: number) => {
        props.onCouponUpdate(
          props.id,
          coupon,
          group,
          typeof values === 'function'
            ? values(config, group, props.crossedNumbers[coupon][group] || [])
            : [...(values as number[])]
        );
      }
    );
  }
}
